forceStringMethod